module.exports = __webpack_public_path__ + "assets/img/35_1131_big.4e110a5a.jpg";